import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ThemeState {
  mode: 'light' | 'dark';
  primaryColor: string;
  animations: boolean;
  compactMode: boolean;
}

const initialState: ThemeState = {
  mode: 'dark', // Default to dark mode
  primaryColor: '#1976d2',
  animations: true,
  compactMode: false,
};

export const themeSlice = createSlice({
  name: 'theme',
  initialState,
  reducers: {
    toggleTheme: (state) => {
      state.mode = state.mode === 'dark' ? 'light' : 'dark';
    },
    setThemeMode: (state, action: PayloadAction<'light' | 'dark'>) => {
      state.mode = action.payload;
    },
    setPrimaryColor: (state, action: PayloadAction<string>) => {
      state.primaryColor = action.payload;
    },
    toggleAnimations: (state) => {
      state.animations = !state.animations;
    },
    toggleCompactMode: (state) => {
      state.compactMode = !state.compactMode;
    },
  },
});

export const { 
  toggleTheme, 
  setThemeMode, 
  setPrimaryColor, 
  toggleAnimations, 
  toggleCompactMode 
} = themeSlice.actions;

export default themeSlice.reducer;
